(ns ui.view.entity-graph.components.sidebar
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [clojure.string :as string]
            [common.localization :as loc]
            [common.entity :as entity]
            [common.schema.entities.graph-reference :as graph-reference]
            [common.schema.entity-types :as entity-types]
            [common.schema.registry :as registry]
            [common.util :as cu]
            [frontend.state.permissions :as permissions]
            [frontend.state.current-session :as session]
            [frontend.utils :as fu]
            [ui.components.radix-ui.dialog.view :as dialog]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [oops.core :as oops]
            [ui.dom-globals :as dg]
            [ui.state.session.sub :as session-sub]
            [ui.util :as uu]
            [ui.components.button.view :as button]
            ;;[ui.components.input.checkbox :as checkbox]
            [ui.editors.labelled-input.view :as labelled-input]
            [ui.view.entity-graph.utils :as utils]
            [ui.view.entity-graph.model :as m]))

;; note: copied from ui.view.nev.sidebar and modified to work with right side
;; TODO extract into more generic component? sidebar content given as children
;;      as opposed to explicit 'sidebar' component below
(defn sheet-content
  [{:keys [side class style] :as props} & children]
  (let [side-classes {:top "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top"
                      :bottom "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom"
                      :left
                      "inset-y-0 w-80 border-r border-l-0 border-y-0 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm"
                      :right
                      "inset-y-0 w-80 border-r-0 border-l border-y-0 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm right-0"}]
    [dialog/dialog-content
     (merge
      {:class (uu/cm
                    ;; FIXME: z-index 201 because view editor full screen modal is z 200. Fix this somehow so no need for these hacks
               "fixed border z-[201] overflow-hidden overflow-y-auto bg-base-light gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-100 data-[state=open]:duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out"
               (get side-classes (or side :right))
               class)
       :style style}
      (dissoc props :side :class :children :style))
     [dialog/dialog-title
      {}
      ""]
     [dialog/dialog-description
      {}
      ""]
     (into [:div {:class "flex h-full"}] children)]))

(def sheet dialog/dialog-root)

(def sheet-portal dialog/dialog-portal)

(def sheet-trigger dialog/dialog-trigger)

(defn other
  [{:graph-reference/keys [source target]} {map-profile-id :db/id}]
  (cond (= source map-profile-id)
        target

        (= target map-profile-id)
        source

        :else
        nil))

(def display-metadata-by-type
  {:graph-reference.type/ownership :graph-meta/ownership-percentage
   :graph-reference.type/board-member :graph-meta/board-member-role
   :graph-reference.type/executive :graph-meta/executive-role
   :graph-reference.type/auditor :graph-meta/auditor-role})

(defn metadata-view
  [_ctx {:keys [graph-reference/type] :as connector}]
  (let [percentage (utils/metadata-value connector :graph-meta/ownership-percentage)
        metadata-attribute (get display-metadata-by-type type)
        percentage? (= metadata-attribute :graph-meta/ownership-percentage)
        metadata-value (utils/metadata-value connector metadata-attribute)
        tenant-schema @(rf/subscribe [::session-sub/tenant-schema])
        {:keys [options] :as _fs} (registry/get-field-schema tenant-schema
                                                             metadata-attribute)
        has-metadata? metadata-value]
    (when has-metadata?
      [:div
       {:class "px-1.5 py-0.5 inline-block bg-base-gloomy font-medium rounded-xl text-xs"}
       (cond percentage?
             (utils/format-percentage percentage)

             (keyword? metadata-value)
             (uu/find-option-label options metadata-value)

             :else
             metadata-value)])))

(defn hidden-connector?
  [{:keys [connectors system-config] :as _hide-rules} {:keys [db/id graph-reference/type]}]
  (if system-config
    (contains? (get-in m/system-level-configs
                       [system-config :hide-connector-types])
               type)
    (contains? connectors id)))

(defn connector-view
  [{:keys [map-profile connector] :as ctx}]
  (let [connector-id (:db/id connector)
        hide-rules @(rf/subscribe [m/hide-rules ctx])
        hidden? (hidden-connector? hide-rules connector)
        other-mp-id (other connector map-profile)
        other-mp @(rf/subscribe [::session-sub/entity other-mp-id])
        editable? (utils/editable-graph-reference? ctx connector)
        ref-type (:graph-reference/type connector)
        connector? (contains? graph-reference/connector-types ref-type)]
    [:div
     {:class (uu/cm
              (when-not connector?
                "")
              "w-full flex gap-1 justify-between items-baseline group/connector")}
     [:div
      {:class "m-0 flex gap-2 items-center text-sm w-[180px]"}
      (when connector?
        [button/secondary-open
         {:tooltip (if hidden?
                     (loc/tr :unhide-connector)
                     (loc/tr :hide-connector))
          :class (uu/cm "p-0 w-5")
          :on-click (fn [_]
                      (rf/dispatch [m/hide-connector
                                    (assoc ctx :connector-id connector-id
                                           :hide? (not hidden?))]))}
         [:i
          {:class (uu/cm "fal"
                         (if hidden?
                           "fa-eye-slash"
                           "fa-eye"))}]])

      [:div
       {:class "flex w-full gap-2 items-center flex-wrap"}
       [:div
        {:class "w-full truncate"}
        (:graph-entity/label other-mp)]
       [metadata-view ctx connector]]]
     [:div
      {:class "flex gap-1"}
      [button/secondary-open
       {:tooltip (if connector?
                   (loc/tr :edit-connector)
                   (loc/tr :edit-relationship))
        :class (uu/cm "p-0"
                      "invisible"
                      (when editable?
                        "group-hover/connector:visible"))
        :on-click (fn [_]
                    (rf/dispatch [m/open-edit-connector
                                  (assoc ctx
                                         :connector-id connector-id
                                         :other-mp-id other-mp-id)]))}
       [:i
        {:class (uu/cm "fal fa-edit")}]]
      [button/secondary-open
       {:tooltip (loc/tr :delete-connection)
        :class (uu/cm "py-0"
                      "invisible"
                      "group-hover/connector:visible")
        :on-click (fn [_]
                    (rf/dispatch [m/start-delete
                                  (assoc ctx
                                         :connector-id connector-id)]))}
       [:i
        {:class (uu/cm "fal fa-trash-alt")}]]]]))

(defn relationships-of-type
  [ctx show-all? type dir {:keys [db/id] :as map-profile}]
  (let [map-profile-id (:db/id map-profile)
        connectors @(rf/subscribe [m/graph-references-of-type-for
                                   (assoc ctx
                                          :map-profile-id id
                                          :connector-type type
                                          :direction dir)])]
    (when (or show-all?
              (seq connectors))
      [:div
       {:class "p-3 flex flex-col gap-2 rounded-lg bg-complement-light"}
       [:div
        {:class "flex gap-1 items-center justify-between"}
        [:div
         {:class "font-semibold text-md"}
         (get-in graph-reference/relationship-list-label [type dir])]
        [button/secondary-open
         {:tooltip (get-in graph-reference/create-gref-label [type dir])
          :class (uu/cm "p-1")
          :on-click (fn [_]
                      (rf/dispatch [m/start-create-connector
                                    (assoc ctx
                                           :map-profile-id map-profile-id
                                           :connector-type type
                                           :direction dir)]))}
         [:i
          {:class (uu/cm "fal clickable fa-plus-circle")}]]]
       (doall
        (for [{:keys [db/id] :as connector} connectors]
          ^{:key (str "c-" id)}
          [connector-view (assoc ctx
                                 :connector connector
                                 :map-profile map-profile)]))])))

(defn any-grefs-empty?
  [ctx types map-profile-id]
  (->> (for [[type dirs] types
             dir dirs]
         @(rf/subscribe [m/graph-references-of-type-for
                         (assoc ctx
                                :map-profile-id map-profile-id
                                :connector-type type
                                :direction dir)]))
       (some empty?)))

(defn relationships
  [{:keys [map-profile-id] :as ctx}]
  (let [map-profile @(rf/subscribe [::session-sub/entity map-profile-id])
        {:graph-entity/keys [entity-type]} map-profile
        map-profile-id (:db/id map-profile)
        types (get graph-reference/connectors-by-entity-type entity-type)
        any-empty? (any-grefs-empty? ctx types map-profile-id)
        ;;TODO: from state:
        show-all? @(rf/subscribe [m/show-all-gref-sections
                                  (assoc ctx :section :connectors)])]
    [:<>
     (doall
      (for [[type dirs] types]
        (for [dir dirs]
          ^{:key (str map-profile-id "-" type "-" dir)}
          [relationships-of-type ctx show-all? type dir map-profile])))
     (when any-empty?
       [:div
        [button/primary-open
         {:class (uu/cm "py-1 text-sm")
          :on-click (fn [_]
                      (rf/dispatch [m/toggle-show-all-gref-sections
                                    (assoc ctx :section :connectors)]))}
         (if show-all?
           (loc/tr :hide-empty)
           (loc/tr :show-all))]])]))

#_(defn hide-relationships-of-type
    [ctx type dir {:keys [db/id] :as map-profile}]
    (let [connectors @(rf/subscribe [m/graph-references-of-type-for
                                     (assoc ctx
                                            :map-profile-id id
                                            :connector-type type
                                            :direction dir)])]
      [:div
       [:div
        {:class "font-bold"}
        (when (seq connectors)
          (get-in relationship-list-label [type dir]))]
       (doall
        (for [{:keys [db/id] :as connector} connectors
              :let [checked? @(rf/subscribe
                               [m/hidden-preview-connector? (assoc ctx
                                                                   :connector-id id)])]]
          ^{:key (str "c-" id)}
          [:div
           {:class "flex"}
           [checkbox/view
            {:value checked?
             :on-change
             (fn [new-checked?]
               (rf/dispatch [m/preview-hide-connector (assoc ctx
                                                             :connector-id id
                                                             :hide? new-checked?)]))}]
           [connector-view (assoc ctx
                                  :connector connector
                                  :map-profile map-profile)]]))]))

#_(defn hide-relationships-buttons
  [{:keys [] :as ctx}]
  (let [connectors? (->> @(rf/subscribe [m/connectors-for ctx])
                         seq)]
    [:div
     {:class "flex"}
     (when connectors?
       [button/sm-secondary-solid
        {:on-click
         (fn [_]
           (rf/dispatch [m/apply-hide-rules ctx]))}
        (loc/tr :apply)])
     [button/sm-secondary-hollow
      {:on-click
       (fn [_]
         (rf/dispatch [m/discard-hide-rules ctx]))}
      (loc/tr :cancel)]]))

#_(defn hide-relationships
    [{:keys [map-profile] :as ctx}]
    (let [{:graph-entity/keys [entity-type]} map-profile
          map-profile-id (:db/id map-profile)
          connectors @(rf/subscribe [m/connectors-for ctx])
          types (get m/connectors-by-entity-type entity-type)]
      [:<>
       (when (seq connectors)
         [:div "Toggle checkboxes to hide/unhide:"])
       (doall
        (for [[type dirs] types]
          (for [dir dirs]
            ^{:key (str map-profile-id "-" type "-" dir)}
            [hide-relationships-of-type ctx type dir map-profile])))
       [hide-relationships-buttons ctx]]))

(defn map-profile-attributes
  [_ entity-type]
  (let [tenant-schema @(rf/subscribe [::session-sub/tenant-schema])
        schema (registry/get-schema tenant-schema entity-type)
        visible-schema (->> schema
                            (filterv (fn [[attribute _fs]]
                                       (let [read? (permissions/field-read-access?
                                                    attribute entity-type nil)]
                                         read?)))
                            (filterv (fn [[a _]]
                                       (= (namespace a)
                                          "graph-entity")))
                            (sort-by (fn [[a _]]
                                       (utils/attr-order a))))]
    visible-schema))

(defn visible?
  [{:keys [visible-for]} entity-type]
  ;; if not defined => visible for all
  (if (nil? visible-for)
    true
    (contains? visible-for entity-type)))

(defn attribute-view
  [{:keys [label value]}]
  [:div
   {:class "m-0 flex items-baseline gap-2 text-sm"}
   [:div
    {:class "w-5/12 font-semibold"}
    (str label ":")]
   [:div
    {:class "w-7/12"}
    (if (string/blank? value)
           "-"
           (str value))]])

(defn graph-references-view
  [{:keys [map-profile-id] :as ctx}]
  (let [map-profile @(rf/subscribe [::session-sub/entity map-profile-id])
        {:graph-entity/keys [entity-type]} map-profile
        map-profile-id (:db/id map-profile)
        all-types (get graph-reference/types-by-entity-type entity-type)
        ;; skip connectors:
        types (->> all-types
                   (remove (fn [[type _]]
                             (contains? graph-reference/connector-types type))))
        any-empty? (any-grefs-empty? ctx types map-profile-id)
        show-all? @(rf/subscribe [m/show-all-gref-sections
                                  (assoc ctx :section :map-profile)])]
    [:<>
     (doall
      (for [[type dirs] types]
        (for [dir dirs]
          ^{:key (str map-profile-id "-" type "-" dir)}
          [relationships-of-type ctx show-all? type dir map-profile])))
     (when any-empty?
       [:div
        [button/primary-open
         {:class (uu/cm "py-1 text-sm")
          :on-click (fn [_]
                      (rf/dispatch [m/toggle-show-all-gref-sections
                                    (assoc ctx :section :map-profile)]))}
         (if show-all?
           (loc/tr :hide-empty)
           (loc/tr :show-all))]])]))

(defn display-attribute
  [{:keys [attribute field-schema map-profile]}]
  [attribute-view {:label (loc/tr attribute)
                   :value (let [val (get map-profile attribute)]
                            (fu/display-data
                             @session/tenant-schema @session/tenant
                             attribute field-schema
                             map-profile
                             :passed-value val
                             :entities @session/entities))}])

(defn attributes-view
  [{:keys [map-profile-id] :as ctx}]
  (let [map-profile @(rf/subscribe [::session-sub/entity map-profile-id])
        map-profile-entity-id (:graph-entity/entity map-profile)
        map-profile-entity @(rf/subscribe [::session-sub/entity map-profile-entity-id])]
    [:div
     {:class "flex flex-col gap-3"}
     [:div
      [attribute-view {:label (loc/tr :official-name)
                       :value (entity/display-string map-profile-entity)}]]
     (doall
      (for [[a {:field/keys [default-visibility]
                :as fs}] (map-profile-attributes
                           ctx (:entity/type map-profile))
            :let [editor-type (:editor default-visibility)]
            :when (and (not= editor-type :editor.type/none)
                       (not= a :graph-entity/entity))]
        ^{:key (str a)}
        [display-attribute {:attribute a
                            :field-schema fs
                            :map-profile map-profile}]))]))

(defn map-profile-curtain
  [{:keys [map-profile-id not-selected?] :as ctx}]
  ;; mount and unmount (see 'finally' block) time events to ensure any
  ;; map-profile-id specific temporary state is properly initialized/discarded
  (r/with-let [_ (when-not not-selected?
                   ;; 'not-selected?' means default-case: main-map-profile is shown
                   (rf/dispatch [m/open-map-profile-curtain
                                 ctx]))]
    (let [map-profile @(rf/subscribe [::session-sub/entity map-profile-id])
          hidden? (not (contains? @(rf/subscribe [m/visible-node-ids-set ctx])
                                  map-profile-id))
          {:graph-entity/keys [label]} map-profile]
      [:div
       {:class "flex flex-col flex-1 gap-4 h-full"}
       [:div
        {:id "map-profile-attributes"
         :class (uu/cm "p-3 flex flex-col gap-3 bg-base-light rounded-lg overflow-y-auto"
                       "max-h-[60%] border border-solid border-base-light-border-paler"
                       "group/map-profile-section")}
        [:div
         {:class "pb-1 flex gap-3 items-center justify-between text-lg leading-6 font-bold"}
         label
         [button/secondary-open
          {:on-click
           (fn [_]
             (rf/dispatch [m/open-edit-map-profile
                           (assoc ctx
                                  :map-profile map-profile)]))}
          [:i
           {:class
            (uu/cm "fal fa-edit cursor-pointer text-md")}]]]
        (when hidden?
          (loc/tr :map-profile-hidden))

        [attributes-view ctx]

        [graph-references-view ctx]]

       [:div
        {:id "connectors"
         :class (uu/cm "p-3 flex flex-col gap-2 bg-base-light flex-1 overflow-y-auto"
                       "rounded-lg border border-solid border-base-light-border-paler"
                       "group/connectors-section")}

        [:div
         {:class "pb-2 font-bold text-lg"}
         (loc/tr :connectors)]
        [relationships ctx]]])
    (finally
      (rf/dispatch [m/close-map-profile-curtain ctx]))))

(defn multiple-map-profiles-curtain
  [{:keys [selected-nodes] :as ctx}]
  (let [map-profiles (->> @(rf/subscribe [m/map-profiles ctx])
                          (filterv (fn [{:keys [db/id]}]
                                     (contains? selected-nodes id))))
        visible-nodes @(rf/subscribe [m/visible-node-ids-set ctx])
        map-profile-ids (->> map-profiles
                             (mapv :db/id))
        positions (-> @(rf/subscribe [m/positions ctx])
                      (select-keys map-profile-ids))
        connectors (->> @(rf/subscribe [m/visible-connectors ctx])
                        (filterv (fn [{:graph-reference/keys [source target]}]
                                   (and (contains? selected-nodes source)
                                        (contains? selected-nodes target)))))
        ;; TODO: hide all selected
        #_#_hiding-view? @(rf/subscribe [m/hiding-view? ctx])]
    [:div
     {:class "p-3 flex flex-col gap-4 bg-base-light rounded-lg shadow-sm"}
     [:div
      {:class (uu/cm "pb-1 flex gap-3 items-center justify-between"
                     "text-lg leading-6 font-bold")}
      (loc/tr :multiple-map-profiles-selected)]
     (->> map-profiles
          (mapv (fn [{:keys [graph-entity/label db/id]}]
                  (str label
                       (when-not (contains? visible-nodes id)
                         " (hidden)"))))
          (string/join ", "))

     [:div
      {:class "font-bold mt-2"}
      #_"Connectors: "]

     [:div
      {:class "mt-2"}
      [button/sm-warning-solid
       {:on-click
        (fn [_]
          (rf/dispatch [m/auto-layout-nodes
                        (assoc ctx
                               :auto-layout? true
                               :map-profiles map-profiles
                               :connectors connectors
                               :positions positions)]))}
       (loc/tr :autolayout-selected-nodes)]]

     [:div
      {:class "mt-2"}
      [button/sm-warning-solid
       {:on-click
        (fn [_]
          (rf/dispatch [m/discard-selected-positions
                        (assoc ctx
                               :map-profiles map-profiles)]))}
       (loc/tr :remove-positioning)]]]))

(def connector-attributes
  [{:label "Percentage" :attribute :graph-meta/ownership-percentage
    :metadata? true
    :editor/type :editor.type/percentage
    :visible-for #{:graph-reference.type/ownership}
    :data/type :data.type/percentage}])

(defn connector-attributes-view
  [{:keys [connector] :as _ctx}]
  (let [connector-type (:graph-reference/type connector)]
    [:div
     {:class (uu/cm "flex-1")}
     (doall
      (for [{:keys [attribute label metadata?]
             data-type :data/type :as defs} connector-attributes
            :when (visible? defs connector-type)]
        ^{:key (str attribute)}
        [attribute-view
         {:label label
          :value (let [raw (if metadata?
                             (utils/metadata-value connector attribute)
                             (get connector attribute))
                       value (if (= data-type :data.type/percentage)
                               (utils/format-percentage raw)
                               raw)]
                   (if (string/blank? value)
                     "-"
                     (str value)))}]))]))

;;TODO connector-specific namespace:
(defn connector-curtain
  [{:keys [connector-id] :as ctx}]
  (let [connector @(rf/subscribe [::session-sub/entity connector-id])
        visible-edge-ids @(rf/subscribe [m/visible-edge-ids-set ctx])
        visible-node-ids @(rf/subscribe [m/visible-node-ids-set ctx])
        connector-type (:graph-reference/type connector)
        editable? (utils/editable-graph-reference? ctx connector)
        source-id (:graph-reference/source connector)
        target-id (:graph-reference/target connector)
        source @(rf/subscribe [::session-sub/entity source-id])
        source-label (:graph-entity/label source)
        target @(rf/subscribe [::session-sub/entity target-id])
        target-label (:graph-entity/label target)]
    [:div
     {:class "p-3 flex flex-col gap-4 bg-base-light rounded-lg shadow-sm"}
     [:div
      {:class "pb-1 flex gap-3 items-center justify-between text-lg leading-6 font-bold"}
      (loc/tr :connector-comma)
      (get graph-reference/labels connector-type)
      [button/secondary-open
       {:tooltip (loc/tr :delete-connection)
        :on-click
        (fn [_]
          (rf/dispatch [m/start-delete ctx]))}
       [:i
        {:class
         (uu/cm "fal fa-trash-alt cursor-pointer text-md")}]]]
     (when-not (contains? visible-edge-ids connector-id)
       [:div
        (loc/tr :space-hidden)])
     [:div
      {:class "relative"}
      [:div
       {:class "py-1.5 px-3 m-0 flex gap-2 justify-between items-center text-sm border border-dashed border-base-light-border-paler hover:border-base-light-border-accent rounded-md group"}
       source-label
       (when-not (contains? visible-node-ids source-id)
         (loc/tr :space-hidden))
       [:div
        {:class "invisible group-hover:visible"}
        [button/square-secondary-open
         {:on-click
          (fn [_]
            (rf/dispatch [m/view-map-profile
                          (assoc ctx
                                 :map-profile-id source-id)]))}
         [:i
          {:class
           "fal fa-external-link"}]]]]
      [:div
       {:class "flex justify-center h-3"}
       [:i
        {:class
         "fal fa-arrows-up-down text-xs"}]]
      [:div
       {:class "py-1.5 px-3 m-0 flex gap-2 justify-between items-center text-sm border border-dashed border-base-light-border-paler hover:border-base-light-border-accent rounded-md group"}
       target-label
       (when-not (contains? visible-node-ids target-id)
         (loc/tr :space-hidden))
       [:div
        {:class "invisible group-hover:visible"}
        [button/square-secondary-open
         {:on-click
          (fn [_]
            (rf/dispatch [m/view-map-profile
                          (assoc ctx
                                 :map-profile-id target-id)]))}
         [:i
          {:class
           "fal fa-external-link"}]]]]]

     (when editable?
       [:div
        {:class (uu/cm "flex justify-between group/connector")}
        [connector-attributes-view (assoc ctx :connector connector)]
        [button/secondary-open
         {:tooltip (loc/tr :edit-connector)
          :class (uu/cm "p-0"
                        "invisible"
                        (when editable?
                          "group-hover/connector:visible"))
          :on-click (fn [_]
                      (rf/dispatch [m/open-edit-connector
                                    (assoc ctx
                                           :connector-id connector-id)]))}
         [:i
          {:class (uu/cm "fal fa-edit")}]]])

     (let [path-type @(rf/subscribe [m/connector-path-type
                                     (assoc ctx
                                            :connector-id
                                            connector-id
                                            :connector-type connector-type
                                            :raw? true)])]
       [labelled-input/view
        {:data-type :data.type/keyword
         :editor-type :editor.type/select
         :label (loc/tr :path-shape)
         :value path-type
         :on-change (fn [new-val _]
                      (when-not (= new-val path-type)
                        (rf/dispatch
                         [m/update-view-config
                          (assoc ctx
                                 :path [:connectors connector-id m/path-type-key]
                                 :value new-val)])))
         :options (into [{:value nil :label (loc/tr :use-default)}]
                        m/path-types)}])

     [:div
      {:class "pt-2 flex flex-col gap-3"}
      [:span
       {:class "font-bold text-md"}
       (loc/tr :connector-endpoints)]
      (let [ctx (assoc ctx :connector-id connector-id)
            source-handle @(rf/subscribe
                            [m/source-handle ctx])
            target-handle @(rf/subscribe
                            [m/target-handle ctx])]
        [:div
         {:class "flex flex-col gap-2"}
         [labelled-input/view
          {:data-type :data.type/keyword
           :editor-type :editor.type/select
           :label source-label
           :value source-handle
           :on-change (fn [new-val _]
                        (when-not (= new-val source-handle)
                          (rf/dispatch [m/update-view-config
                                        (assoc ctx
                                               :path [:connectors m/source-handle-key
                                                      connector-id]
                                               :value new-val)])))
           :options (into [{:value nil :label (loc/tr :use-default)}]
                          m/source-handle-options)}]
         [labelled-input/view
          {:data-type :data.type/keyword
           :editor-type :editor.type/select
           :label target-label
           :value target-handle
           :on-change (fn [new-val _]
                        (when-not (= new-val target-handle)
                          (rf/dispatch [m/update-view-config
                                        (assoc ctx
                                               :path [:connectors m/target-handle-key
                                                      connector-id]
                                               :value new-val)])))
           :options (into [{:value nil :label (loc/tr :use-default)}]
                          m/target-handle-options)}]])]
     [:div
      {:class "pt-2 flex flex-col gap-3"}
      (let [ctx (assoc ctx :connector-id connector-id)
            label-position @(rf/subscribe
                             [m/label-position ctx])]
        [:div
         [labelled-input/view
          {:data-type :data.type/keyword
           :editor-type :editor.type/select
           :label (loc/tr :label-position)
           :value label-position
           :on-change (fn [new-val _]
                        (when-not (= new-val label-position)
                          (rf/dispatch [m/update-view-config
                                        (assoc ctx
                                               :path [:connectors m/label-positions-key
                                                      connector-id]
                                               :value new-val)])))
           :options (into [#_{:value nil :label "Use default"}]
                          [{:value :center :label (loc/tr :center)}
                           {:value :source :label (loc/tr :next-to [source-label])}
                           {:value :target :label (loc/tr :next-to [target-label])}])}]])]]))

(defn connector-info
  [{:keys [connector-id] :as ctx}]
  (let [connector @(rf/subscribe [::session-sub/entity connector-id])
        visible-edge-ids @(rf/subscribe [m/visible-edge-ids-set ctx])
        visible-node-ids @(rf/subscribe [m/visible-node-ids-set ctx])
        source-id (:graph-reference/source connector)
        target-id (:graph-reference/target connector)
        source @(rf/subscribe [::session-sub/entity source-id])
        source-label (:graph-entity/label source)
        target @(rf/subscribe [::session-sub/entity target-id])
        target-label (:graph-entity/label target)]
    [:div
     [:div
      source-label
      (when-not (contains? visible-node-ids source-id)
        (loc/tr :space-hidden))
      [:button
       {:on-click
        (fn [_]
          (rf/dispatch [m/view-map-profile
                        (assoc ctx
                               :map-profile-id source-id)]))}
       [:i
        {:class
         "fal fa-external-link"}]]
      " -> "
      target-label
      (when-not (contains? visible-node-ids target-id)
        (loc/tr :space-hidden))
      [:button
       {:on-click
        (fn [_]
          (rf/dispatch [m/view-map-profile
                        (assoc ctx
                               :map-profile-id target-id)]))}
       [:i
        {:class
         "fal fa-external-link"}]]
      (when-not (contains? visible-edge-ids connector-id)
        (loc/tr :space-hidden))]]))

;; wip:
(defn multiple-connectors-curtain
  [{:keys [selected-edges] :as ctx}]
  (let [connectors (->> selected-edges
                        (mapv (fn [id]
                                @(rf/subscribe [::session-sub/entity id]))))
        by-type (->> connectors
                     (group-by :graph-reference/type))]
    [:div
     {:class "p-3 flex flex-col gap-4 bg-base-light rounded-lg shadow-sm"}
     [:div
      {:class (uu/cm "pb-1 flex gap-3 items-center justify-between"
                     "text-lg leading-6 font-bold")}
      (loc/tr :multiple-connectors-selected)]
     (doall
      (for [[type connectors] by-type]
        ^{:key (str type)}
        [:div
         {:class "flex flex-col gap-2"}
         [:div
          {:class "font-semibold"}
          (loc/tr type)]
         (doall
          (for [{:keys [db/id] :as _connector} connectors]
            ^{:key (str id)}
            [connector-info (assoc ctx :connector-id id)]))]))]))

(defn viewed-curtain
  [{:keys [viewed-id] :as ctx}]
  (let [viewed @(rf/subscribe [::session-sub/entity viewed-id])
        entity-type (:entity/type viewed)
        entity-type (if (contains? entity-types/graph-entity-types entity-type)
                      :entity.type/graph-entity
                      entity-type)]
    [:div
     {:class "flex flex-col flex-1 overflow-auto"}

     (case entity-type
       :entity.type/graph-entity
       [map-profile-curtain (assoc ctx :map-profile-id viewed-id)]

       :entity.type/graph-reference
       [connector-curtain (assoc ctx :connector-id viewed-id)]

       nil)]))

(defn curtain-state
  [ctx]
  (let [one-selected-node @(rf/subscribe [m/one-selected-node ctx])
        ;; tweaking proper handling of selection when nodes become hidden:
        ;;selected-nodes @(rf/subscribe [m/selected-visible-nodes ctx])
        selected-nodes @(rf/subscribe [m/selected-nodes ctx])
        one-selected-edge @(rf/subscribe [m/one-selected-edge ctx])
        ;;selected-edges @(rf/subscribe [m/selected-visible-edges ctx])
        selected-edges @(rf/subscribe [m/selected-edges ctx])]
    (cond #_#_settings?
          [settings/view (assoc ctx :global-settings? true)]

          ;;spiking: explicitly viewed map-profiles/connectors
          ;; -not clear how to make reasonable - current approach
          ;;  is somewhat conflating viewing vs. selecting entities
          #_#_viewed
            [viewed-curtain (assoc ctx :viewed-id viewed)]

          one-selected-node
          :map-profile

          (cu/multiple? selected-nodes)
          :multiple-map-profiles

          one-selected-edge
          :connector

          (cu/multiple? selected-edges)
          :multiple-connectors

          :else
          nil)))

(def curtain-badge-text
  {:map-profile (loc/tr :map-profile-viewed)
   :multiple-map-profiles (loc/tr :multiple-map-profiles-viewed)
   :connector (loc/tr :connector-viewed)
   :multiple-connectors (loc/tr :multiple-connectors-viewed)})

(defn curtain
  [ctx]
  (let [one-selected-node @(rf/subscribe [m/one-selected-node ctx])
        ;; tweaking proper handling of selection when nodes become hidden:
        ;;selected-nodes @(rf/subscribe [m/selected-visible-nodes ctx])
        selected-nodes @(rf/subscribe [m/selected-nodes ctx])
        one-selected-edge @(rf/subscribe [m/one-selected-edge ctx])
        ;;selected-edges @(rf/subscribe [m/selected-visible-edges ctx])
        selected-edges @(rf/subscribe [m/selected-edges ctx])
        main-map-profile-id @(rf/subscribe [m/main-map-profile-id ctx])
        curtain (curtain-state ctx)]
    (case curtain
      :map-profile
      ^{:key (str one-selected-node)}
      [viewed-curtain (assoc ctx :viewed-id one-selected-node)]

      :multiple-map-profiles
      [multiple-map-profiles-curtain (assoc ctx :selected-nodes selected-nodes)]

      :connector
      ^{:key (str one-selected-edge)}
      [viewed-curtain (assoc ctx :viewed-id one-selected-edge)]

      :multiple-connectors
      [multiple-connectors-curtain (assoc ctx :selected-edges selected-edges)]

      ;; default: display main-map-profile
      [viewed-curtain (assoc ctx
                             :viewed-id main-map-profile-id
                             ;; skip some map-profile-curtain initialization:
                             :not-selected? true)])))

(defn sidebar
  [ctx]
  [curtain ctx])

(defn pin-button
  [ctx]
  [button/square-secondary-hollow
   {:on-click #(rf/dispatch [m/set-sidebar-mode
                             (assoc ctx :sidebar-mode :pinned)])
    :class "bg-base-light hover:bg-base-regular"
    :tooltip (loc/tr :pin-sidebar)}
   [:i {:class "fal fa-map-pin"}]])

(defn expanded-toggle
  [{:keys [expanded?] :as ctx}]
  [button/square-secondary-hollow
   {:on-click #(rf/dispatch [m/set-sidebar-mode
                             (assoc ctx :sidebar-mode
                                    (if expanded?
                                      :collapsed
                                      :expanded))])
    :class "bg-base-light hover:bg-base-regular"
    :tooltip (if expanded?
               (loc/tr :collapse-sidebar)
               (loc/tr :expand-sidebar))}
   [:i {:class (uu/cm "fal"
                      (if expanded?
                        "fa-chevron-right"
                        "fa-chevron-left"))}]])

(defn close-curtain-button
  [ctx]
  [button/secondary-open
   {:class (uu/cm "p-0"
                  (when-not (curtain-state ctx)
                    "hidden"))
    :on-click (fn [_]
                ;; we might later need more specific events based on curtain-state
                (rf/dispatch [m/close-viewed-entity ctx]))}
   [:i
    {:class "fal fa-times cursor-pointer text-xl"}]])

(defn pinned-sidebar
  [ctx]
  [:div
   {:class "max-h-full relative flex flex-col"}
   [:div
    {:class "py-2 flex justify-between items-center gap-2 shrink-0"}
    [expanded-toggle (assoc ctx :expanded? true)]
    [close-curtain-button ctx]]
   [sidebar ctx]])

(defn edge?
  [element]
  (= (cu/str-trim-lcase (.-tagName element)) "path"))

(defn node?
  [element]
  (or (some-> element
              .-classList
              (.contains "custom-react-flow-node"))
      (dg/find-parent-with-class element "custom-react-flow-node")))

(defn unpinned-sidebar
  [{:keys [sidebar-position] :as ctx}]
  (r/with-let [local-state (r/atom {})]
    (let [sidebar-mode @(rf/subscribe [m/sidebar-mode ctx])
          open? (= sidebar-mode :expanded)
          selecting? @(rf/subscribe [m/selecting? ctx])
          {:keys [top _left _right]} @sidebar-position]
      [:div
       [sheet
        {:open open?
         :modal false
         :onOpenChange (fn [new-open?]
                         (let [prevent-close? (or (and open?
                                                       (not new-open?)
                                                       (:prevent-close? @local-state))
                                                  selecting?)]
                           (swap! local-state assoc :prevent-close? false)
                           (when-not prevent-close?
                             (rf/dispatch-sync [m/set-sidebar-mode
                                                (assoc ctx
                                                       :sidebar-mode
                                                       (if new-open? :expanded :collapsed))]))))}
        [sheet-trigger
         {:asChild true}
         [:span
          {:class "flex justify-center flex-col gap-3"}
          [button/square-secondary-hollow
           {:class "relative"
            :tooltip (loc/tr :expand-sidebar)}
           [:i {:class "fal fa-chevron-left"}]
           #_(when-let [text (get curtain-badge-text (curtain-state ctx))]
               [:span
                {:class (uu/cm "absolute right-0 top-0 badge badge-pill"
                               "bg-primary")}
                ""])]
        ;;indicator (badge) that curtain/sidebar contains something:
          (when-let [text (get curtain-badge-text (curtain-state ctx))]
            [tooltip/view
             {:delay-duration 100
              :side :bottom
              :align :center}
             [:span
              {:class (uu/cm "right-0 top-0 py-1 px-2"
                             "badge badge-pill"
                             "bg-secondary-regular text-secondary-regular-text-paler opacity-75")}
              [:i
               {:class (uu/cm "fas fa-info")}]]
             text])]]
        [sheet-portal
         {}
       ;; Very important to wrap in fragment, otherwise crashes the ui
       ;; Probably related to the way that refs are passed in reagent/hiccup elements
         [:<>
          [sheet-content
           {:id "nev-sidebar-content-container"
            :side :right
            :style {;;"--sidebar-left" (str left "px")
                    "--sidebar-top" (str top "px")}
            :class "overflow-hidden left-[var(--sidebar-left)] top-[var(--sidebar-top)] h-[calc(100vh-var(--sidebar-top))]"
            :onPointerDownOutside (fn [^js e]
                                    (let [target (.-target e)
                                          is-node? (node? target)
                                          is-edge? (edge? target)]
                                      (when (and open?
                                                 (or is-node?
                                                     is-edge?))
                                        (swap! local-state
                                               assoc :prevent-close? true))
                                      nil))
            :onOpenAutoFocus (fn [e]
                               (oops/ocall e "preventDefault"))}
           [:div
            {:class "p-2 relative h-full w-full flex flex-col bg-complement-light"}
            [:div
             {:class "py-2 flex justify-between items-center gap-2 shrink-0"}
             [:div
              {:class "min-w-12 flex gap-2"}
              [pin-button ctx]]
             [close-curtain-button ctx]]
            [sidebar ctx]]]]]]])))

(defn view
  [ctx]
  (r/with-let [sidebar-position (r/atom {:top 0
                                         :left 0
                                         :right 0
                                         :bottom 0})]
    (let [pinned? @(rf/subscribe [m/sidebar-pinned? ctx])]
      [:div
       {:ref (fn [ref]
               (when ref
                 (let [rect (oops/ocall ref "getBoundingClientRect")
                       top (oops/oget rect "top")
                       left (oops/oget rect "left")
                       bottom (oops/oget rect "bottom")
                       right (oops/oget rect "right")]
                   (reset! sidebar-position {:top top
                                             :left left
                                             :right right
                                             :bottom bottom}))))
        :on-click (fn [_]
                    (rf/dispatch [m/close-node-menu ctx])
                    (rf/dispatch [m/close-edge-menu ctx]))
        :on-context-menu (fn [_]
                           (rf/dispatch [m/close-node-menu ctx])
                           (rf/dispatch [m/close-edge-menu ctx]))
        :class (uu/cm "p-2 relative h-full w-full flex flex-col bg-complement-light"
                      (if pinned? "w-80" "w-10")
                      "")}
       (if pinned?
         [pinned-sidebar ctx]
         [unpinned-sidebar
          (assoc ctx
                 :sidebar-position sidebar-position)])])))
